import { render, staticRenderFns } from "./pt.vue?vue&type=template&id=751c42e5&scoped=true"
import script from "./pt.vue?vue&type=script&lang=js"
export * from "./pt.vue?vue&type=script&lang=js"
import style0 from "./pt.vue?vue&type=style&index=0&id=751c42e5&lang=css"
import style1 from "./pt.vue?vue&type=style&index=1&id=751c42e5&rel=stylesheet%2Fscss&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c42e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751c42e5')) {
      api.createRecord('751c42e5', component.options)
    } else {
      api.reload('751c42e5', component.options)
    }
    module.hot.accept("./pt.vue?vue&type=template&id=751c42e5&scoped=true", function () {
      api.rerender('751c42e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/pt.vue"
export default component.exports